import React, { useState } from "react";
import "./policyDetails.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import AxiosInstance from "../../../AxiosInstance";
import { Button, DatePicker, Divider, message } from "antd";
import OtherPageHeader from "../../../components/OtherHeader";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { uploadPolicyDocumentToAWS } from "../../Helper/uploadDocument";
export default function PolicyDetails() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({ mode: "onChange" });
  const [loader, setLoader] = useState(false);
  const [annualStatementDoc, setAnnualStatementDoc] = useState(null);
  const [lastPremiumPaidDoc, setLastPremiumPaidDoc] = useState(null);
  const [policyPackDoc, setPolicyPack] = useState(null);
  const [premiumValue, setPremiumValue] = useState("");
  const { state } = useLocation();
  const [showReject, setShowReject] = useState(false);
  const [rejectionReason, setRejectionReason] = useState(false);
  const [nomineeDetails, setNomineeDetails] = useState([]);
  const handleClose = () => setShowReject(false);
  const handleShow = () => setShowReject(true);
  const [benifitIllustrationDoc, setbenifitIllustrationDoc] = useState();
  const [nomineeRequired, setNomineeRequired] = useState(false);

  async function handleDocument(event, target) {
    switch (target) {
      case "annualStatement":
        setAnnualStatementDoc(event.target.files[0]);
        break;
      case "lastPremiumPaid":
        setLastPremiumPaidDoc(event.target.files[0]);
        break;
      case "benefitIllustration":
        errors.benefitIllustration = false;
        setValue("benifitIllustrationDoc", "empty");
        setbenifitIllustrationDoc(event.target.files[0]);
        break;
      default:
        setPolicyPack(event.target.files[0]);
        break;
    }
  }

  // async function uploadDocumentToAWS(file) {
  //   const url = "/common/upload-policy-document";
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   const config = {
  //     headers: {
  //       "content-type": "multipart/form-data",
  //     },
  //   };
  //   try {
  //     let response = await AxiosInstance().post(url, formData, config);
  //     return response.data["policyContractFileName"];
  //   } catch (e) {
  //     return "";
  //   }
  // }
  useEffect(() => {
    let ignore = false;

    if (!ignore) {
      if (state && state.policy && state.policy.status === "REJECTED") {
        handleShow();
      }
    }
    return () => {
      ignore = true;
    };
  }, []);

  // const navigate = useNavigate();
  const onSubmit = async (value) => {
    console.log(annualStatementDoc);

    try {
      // if(annualStatementDoc||lastPremiumPaidDoc||policyPackDoc){
      //   alertError("Please Upload One Document");
      //   return;
      // }
      if (
        value.nomineeContact ||
        value.nomineeEmail ||
        value.nomineeDob ||
        value.nomineeName
      ) {
        setNomineeRequired(true);
      } else {
        setNomineeRequired(false);
      }
      value.sumAssured = parseInt(value.sumAssured);
      value.surrenderValue = parseInt(value.surrenderValue);
      value.premiumPaymentTerm = parseInt(value.premiumPaymentTerm);
      value.policyTerm = parseInt(value.policyTerm);
      setLoader(true);
      console.log("Values.before upload..", value);
      value.annualStatementDoc = await uploadPolicyDocumentToAWS(
        annualStatementDoc,
        state.policy.policyId
      );
      value.lastPremiumDoc = await uploadPolicyDocumentToAWS(
        lastPremiumPaidDoc,
        state.policy.policyId
      );
      value.policyPackDoc = await uploadPolicyDocumentToAWS(
        policyPackDoc,
        state.policy.policyId
      );
      value.benifitIllustrationDoc = await uploadPolicyDocumentToAWS(
        benifitIllustrationDoc,
        state.policy.policyId
      );

      value.nominees = [
        {
          contactNo: value.nomineeContact,
          email: value.nomineeEmail,
          name: value.nomineeName,
          dob: value.nomineeDob,
        },
      ];
      // if (value.nomineeName) {
      //   value.nominees[0] = { ...value.nominees[0], name: value.nomineeName };
      // }
      // if (value.nomineeContact) {
      //   value.nomineeContact[0] = {
      //     ...value.nominees[0],
      //     name: value.nomineeContact,
      //   };
      // }
      delete value.nomineeContact;
      delete value.nomineeEmail;
      delete value.nomineeName;
      delete value.nomineeDob;
      value.productIncome = parseInt(value.productIncome);
      value.policyNumber = state && state.policy && state.policy.policyNumber;
      AxiosInstance()
        .put("/policy/" + state.policy.policyId, value)
        .then(() => {
          window.location.href = "/phdashboard";
        })
        .catch((err) => {
          message.error(err.response.data.message);
        });
    } catch (error) {
      console.lor(error);
      message.error(error.response.data.message);
    }
    setLoader(false);
  };

  const issueDateChange = (_, dateString) => {
    errors.issueDate = false;
    setValue("issueDate", dateString);
  };
  const premiumDueDate = (_, dateString) => {
    errors.premiumDueDate = false;
    setValue("premiumDueDate", dateString);
  };
  const lastPremiumPaid = (_, dateString) => {
    errors.lastPremiumPaidDate = false;
    setValue("lastPremiumPaidDate", dateString);
  };
  const onNomineeUpdate = (e) => {
    const nomineePayload = nomineeDetails;
    nomineePayload[0] = {
      ...nomineePayload[0],
      [e.target.name]: e.target.value,
    };
    setNomineeDetails(nomineePayload);
  };

  const navigate = useNavigate();

  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <Modal show={showReject} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Reason for Rejection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {state && state.policy && state.policy["rejectionReason"]}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
      <section className="section-preview py-3">
        <div className="container">
          <div className="row mx-1">
            <div className="col-lg-7 lg-order-1 sx-order-2">
              <div className="common-width">
                <button
                  type="submit"
                  title="back-button"
                  className="back-button mb-1"
                  onClick={() => navigate(-1)}
                >
                  {" "}
                  <i className="fa fa-angle-left" /> Back
                </button>
                <h2 className="mt-5">Policy Details</h2>
                <p>
                  We are almost there, let&apos;s fill in the rest of the
                  details
                </p>
                <form id="policyDetailsForm" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="md-form">
                        <label htmlFor="policyNumber">Policy Number</label>
                        <input
                          type="text"
                          className="form-control"
                          id="policyNumber"
                          placeholder={
                            state && state.policy && state.policy.policyNumber
                          }
                          disabled="disabled"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="md-form">
                        <label htmlFor="surrenderValue">Surrender Value</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.surrenderValue ? "is-invalid" : ""
                          }`}
                          id="surrenderValue"
                          placeholder="Enter Surrender Value"
                          {...register("surrenderValue", {
                            pattern: {
                              value: /^[0-9]*$/i,
                              message: "should be a non negative number",
                            },
                          })}
                        />

                        <div className="invalid-feedback">
                          {errors?.surrenderValue?.message}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      {" "}
                      <label htmlFor="issueDate">Issue Date</label>
                      <div className="md-form">
                        <Controller
                          name="issueDate"
                          control={control}
                          errors={errors}
                          render={(props) => (
                            <DatePicker
                              inputReadOnly
                              className={`form-control${
                                errors.issueDate ? " is-invalid" : ""
                              }`}
                              onChange={issueDateChange}
                              disabledDate={(current) => {
                                return (
                                  current && current > moment().add(0, "month")
                                );
                              }}
                            />
                          )}
                        />
                        <div className="invalid-feedback">
                          Issue Date is required
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="premiumPayementTerm">
                        Premium Payment Term (Yrs)
                      </label>
                      <div className="md-form">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.premiumPaymentTerm ? "is-invalid" : ""
                          }`}
                          id="premiumPayementTerm"
                          placeholder="Enter Premium Payment Term"
                          {...register("premiumPaymentTerm", {
                            validate: {
                              validateNumber: (_) => {
                                setPremiumValue(_);
                              },
                            },

                            pattern: {
                              value: /^[0-9]*$/i,
                              message: "should be a non negative number",
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors?.premiumPaymentTerm?.message}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="policyTerm">Policy Term (Yrs)</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.policyTerm ? "is-invalid" : ""
                        }`}
                        id="policyTerm"
                        placeholder="Enter Policy Term"
                        {...register("policyTerm", {
                          validate: {
                            validateNumber: (_) => {
                              if (
                                _ &&
                                premiumValue &&
                                parseInt(premiumValue) > parseInt(_)
                              ) {
                                return "policy term should be greater than premium payment term";
                              }
                            },
                          },
                          // min: {
                          //   value: parseInt(getValue("premiumPaymentTerm"))??0,
                          //   message: "annual premium should be greater or equal to 5000", // JS only: <p>error message</p> TS only support string
                          // },
                          pattern: {
                            value: /^[0-9]*$/i,
                            message: "should be a non negative number",
                          },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.policyTerm?.message}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="premiumDueDate">Premium Due Date</label>
                      <div className="md-form">
                        <Controller
                          name="premiumDueDate"
                          control={control}
                          errors={errors}
                          render={(props) => (
                            <DatePicker
                              inputReadOnly
                              className={`form-control${
                                errors.premiumDueDate ? " is-invalid" : ""
                              }`}
                              onChange={premiumDueDate}
                            />
                          )}
                        />
                        <div className="invalid-feedback">
                          Premium Due Date is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="lastPremiumPaidDate">
                        Last Premium Paid Date
                      </label>
                      <div className="md-form">
                        <Controller
                          name="lastPremiumPaidDate"
                          control={control}
                          errors={errors}
                          render={(props) => (
                            <DatePicker
                              inputReadOnly
                              className={`form-control${
                                errors.lastPremiumPaidDate ? " is-invalid" : ""
                              }`}
                              onChange={lastPremiumPaid}
                              disabledDate={(current) => {
                                return (
                                  current && current > moment().add(0, "month")
                                );
                              }}
                            />
                          )}
                        />
                        <div className="invalid-feedback">
                          Last Premium Paid Date is required
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="policyTerm">Sum Assured</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.sumAssured ? "is-invalid" : ""
                        }`}
                        id="sumAssured"
                        placeholder="Enter Sum Assured"
                        {...register("sumAssured", {
                          pattern: {
                            value: /^[0-9]*$/i,
                            message: "invalid value",
                          },
                        })}
                      />
                      <div className="invalid-feedback">
                        Sum Assured is required
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="policyTerm">Product Income</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.productIncome ? "is-invalid" : ""
                        }`}
                        id="sumAssured"
                        placeholder="Enter Product Income"
                        {...register("productIncome", {
                          pattern: {
                            value: /^[0-9]*$/i,
                            message: "invalid value",
                          },
                        })}
                      />
                      <div className="invalid-feedback">
                        Product Income is required
                      </div>
                    </div>
                  </div>

                  <h3 className="pt-2">Nominee Details</h3>
                  <Divider className="mt-0" />
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="name">Nominee Name</label>
                      <div className="md-form">
                        <Controller
                          name="nomineeName"
                          control={control}
                          errors={errors}
                          render={(props) => (
                            <input
                              type="text"
                              className={`form-control${
                                errors.nomineeName ? " is-invalid" : ""
                              }`}
                              id="nomineeName"
                              name="nomineeName"
                              placeholder="Enter Nominee Name"
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                              {...register("nomineeName", {
                                required: nomineeRequired,
                                pattern: {
                                  value: /^[a-z ,.'-]+$/i,
                                  message: "Enter valid Name",
                                },
                              })}
                            />
                          )}
                        />

                        {errors?.nomineeName && (
                          <div className="invalid-feedback">
                            {errors?.nomineeName?.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="nomineeEmail">Nominee Email</label>
                      <input
                        type="email"
                        className={`form-control${
                          errors.nomineeEmail ? " is-invalid" : ""
                        }`}
                        id="nomineeEmail"
                        name="nomineeEmail"
                        placeholder="Enter Nominee Email"
                        // onChange={onNomineeUpdate}
                        {...register("nomineeEmail", {
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {errors?.nomineeEmail && (
                        <div className="invalid-feedback">
                          {errors?.nomineeEmail?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="lastPremiumPaidDate">
                        Nominee Mobile Number
                      </label>
                      <div className="md-form">
                        <input
                          type="text"
                          maxLength={10}
                          className={`form-control${
                            errors.nomineeContact ? " is-invalid" : ""
                          }`}
                          id="nomineeContact"
                          name="nomineeContact"
                          placeholder="Enter Nominee Mobile Number"
                          // onChange={onNomineeUpdate}
                          {...register("nomineeContact", {
                            required: nomineeRequired,
                            pattern: {
                              value:
                                /^(\+?\d{1,4}[\s-])?(?!0+\s+,?$)\d{10}\s*,?$/i,
                              message: "mobile number must be 10 digits",
                            },
                          })}
                        />
                        {errors?.nomineeContact && (
                          <div className="invalid-feedback">
                            {errors?.nomineeContact?.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="dob">Nominee DOB</label>
                      <Controller
                        name="dob"
                        control={control}
                        errors={errors}
                        render={() => (
                          <DatePicker
                            inputReadOnly
                            id="dob"
                            name="dob"
                            className={`form-control`}
                            onChange={(_, data) => {
                              setValue("nomineeDob", new Date(data));
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <label
                    className="form-check-label mt-3"
                    htmlFor="exampleCheck1"
                  >
                    Upload any 1 of the below Docuements (in PDF, JPG, PNG)
                  </label>
                  <div className="mb-3 mt-2">
                    <label htmlFor="formFile" className="form-label">
                      Policy Annual Statement
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="annualStatement"
                      onChange={(event) => {
                        handleDocument(event, "annualStatement");
                      }}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Last Premium Paid Receipt
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="formFile"
                      onChange={(event) => {
                        handleDocument(event, "lastPremiumPaid");
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Policy Pack
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="formFile"
                      onChange={(event) => {
                        handleDocument(event, "");
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Benefit Illustration
                    </label>
                    <Controller
                      name="benefitIllustration"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <input
                          className={`form-control ${
                            errors.benefitIllustration ? "is-invalid" : ""
                          }`}
                          type="file"
                          id="benefitIllustration"
                          onChange={(event) => {
                            handleDocument(event, "benefitIllustration");
                          }}
                        />
                      )}
                    />
                    <div className="invalid-feedback">
                      Benefit Illustration is required
                    </div>
                  </div>
                </form>
                <button className="normal-button mb-5" form="policyDetailsForm">
                  {loader ? "Loading" : "Submit"}
                </button>
              </div>
            </div>
            <div className="col-lg-5 lg-order-2 text-center sx-order-1">
              <img
                className="policy-details-image"
                src="/assets/Frame-897.jpg"
                width="70%"
                alt=""
              />
              <p className="d-none d-md-block">
                Our magic begins where your submission ends!
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
